<template>
  <div class="login-container">
    <div class="login-card">
      <div class="logo-top">
        <img src="@/assets/talento_agv/img/home/Logo-agv-color.svg" alt="Logo" @click="$router.push('/')"
          style="cursor: pointer" />
      </div>

      <a v-if="showCreateAccount || showForgotPassword || showVerifyAccount || showVerifyResetCode || showResetPasswordForm" class="local-back-btn"
        @click="returnLogin()">
        Volver
      </a>

      <div class="logo-section">
        <p class="welcome-text">
          {{
            showCreateAccount
              ? "¡Únete a nosotros!"
              : showForgotPassword
                ? "¡Recupera tu contraseña!"
                : showVerifyResetCode
                  ? "¡Verifica tu código!"
                  : showResetPasswordForm
                    ? "¡Restablece tu contraseña!"
                    : showVerifyAccount
                      ? "¡Verifica tu cuenta!"
                      : "¡Un gusto verte de nuevo!"
          }}
        </p>
      </div>

      <!-- CREATE ACCOUNT -->
      <form v-if="showCreateAccount" @submit.prevent="onCreateAccount" novalidate>
        <div class="form-group">
          <input type="text" class="form-control" placeholder="Nombres" v-model="createAccountForm.name" required />
        </div>

        <!-- <div class="form-group">
          <input
            type="text"
            class="form-control"
            placeholder="Usuario"
            v-model="createAccountForm.username"
            required
          />
        </div> -->

        <div class="form-group">
          <input type="text" class="form-control" placeholder="Apellido Paterno" v-model="createAccountForm.ap_paterno"
            required />
        </div>

        <div class="form-group">
          <input type="text" class="form-control" placeholder="Apellido Materno" v-model="createAccountForm.ap_materno"
            required />
        </div>

        <div class="form-group">
          <input type="text" class="form-control" placeholder="Correo" v-model="createAccountForm.email" required />
        </div>

        <div class="form-group password-container">
          <input :type="showPassword ? 'text' : 'password'" class="form-control" placeholder="Contraseña"
            v-model="createAccountForm.password" required />
          <!-- Icono del ojito -->
          <span class="toggle-password" @click="showPassword = !showPassword">
            <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
          </span>
        </div>

        <div class="form-group d-flex align-items-center">
          <input type="checkbox" id="acceptTerms" v-model="createAccountForm.acceptTerms" required
            style="width: 18px; height: 18px; margin-right: 8px" />
          <label for="acceptTerms" class="mb-0" style="font-size: 0.95rem">
            Acepto los
            <a class="text-conditions cursor-pointer" @click.prevent="openTerms">
              Términos y condiciones
            </a>
          </label>
        </div>

        <div class="d-flex justify-content-center">
          <button type="submit" class="btn btn-create-account" :disabled="loading">
            <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            <span v-if="loading" class="loading-text">Cargando...</span>
            <span v-else>Crear cuenta</span>
          </button>
        </div>
      </form>

      <!-- FORGOT PASSWORD -->
      <form v-else-if="showForgotPassword" @submit.prevent="sendRecoveryEmail" novalidate>
        <div class="form-group">
          <input type="email" class="form-control" placeholder="Correo electrónico" v-model="emailForgotPassword"
            @input="forgotEmailNotFound = false" required />
        </div>

        <!-- Aviso cuando el correo no existe o no está vinculado a una cuenta -->
        <div v-if="forgotEmailNotFound" class="recovery-alert recovery-alert-error">
          <p class="mb-2">
            <strong>Cuenta no encontrada:</strong> El correo ingresado no existe o no está vinculado a una cuenta.
            Te invitamos a crear una cuenta para continuar.
          </p>
        </div>

        <div v-if="!forgotEmailNotFound" class="d-flex flex-column align-items-center">
          <button type="submit" class="btn btn-create-account" :disabled="loading">
            <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            <span v-if="loading" class="loading-text">Cargando...</span>
            <span v-else>Enviar correo</span>
          </button>

          <div class="register-link">
            <a href="#" @click.prevent="returnLogin()">Volver</a>
          </div>
        </div>

        <div v-else class="d-flex flex-column align-items-center">
          <button type="button" class="btn btn-create-account" @click="goToCreateAccountFromForgot()">
            Crear una cuenta
          </button>

          <button type="button" class="btn btn-login mb-2" @click="returnLogin()">
            Volver
          </button>
        </div>
      </form>

      <!-- VERIFY RESET PASSWORD CODE -->
      <form v-else-if="showVerifyResetCode" @submit.prevent="onVerifyResetCode" novalidate>
        <!-- <div class="recovery-alert recovery-alert-info">
          {{ resetNoticeMessage || "SI EL CORREO LE PERTENECE A UNA CUENTA SE ENVIARÁ EL CORREO DE REESTABLECIMIENTO" }}
        </div> -->

        <div class="form-group">
          <input type="text" class="form-control" placeholder="Código de restablecimiento (6 dígitos)"
            v-model="resetVerifyCode" maxlength="6" inputmode="numeric" required
            @input="resetVerifyCode = (resetVerifyCode || '').replace(/[^0-9]/g, '').slice(0, 6)" />
          <small class="timer-text">
            Tiempo restante: <strong>{{ formatTimer(timerSec) }}</strong>
          </small>
        </div>

        <button type="submit" class="btn btn-login" :disabled="loadingVerify">
          <span v-if="loadingVerify" class="spinner-border spinner-border-sm me-2" role="status"
            aria-hidden="true"></span>
          <span v-if="loadingVerify" class="loading-text">Cargando...</span>
          <span v-else>Verificar código</span>
        </button>

        <button type="button" class="btn btn-create-account" :disabled="loadingResend || !canResend"
          @click="onResendResetCode">
          <span v-if="loadingResend" class="spinner-border spinner-border-sm me-2" role="status"
            aria-hidden="true"></span>
          <span v-if="loadingResend" class="loading-text">Cargando...</span>
          <span v-else>Reenviar código</span>
        </button>

        <div class="register-link">
          <a href="#" @click.prevent="returnLogin()">Volver</a>
        </div>
      </form>

      <!-- RESET PASSWORD FORM -->
      <form v-else-if="showResetPasswordForm" @submit.prevent="onSubmitResetPassword" novalidate>
        <div class="form-group password-container">
          <input :type="showNewPassword ? 'text' : 'password'" class="form-control" placeholder="Nueva contraseña"
            v-model="resetPasswordForm.password" required />
          <span class="toggle-password" @click="showNewPassword = !showNewPassword">
            <i :class="showNewPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
          </span>
        </div>

        <div class="form-group password-container">
          <input :type="showConfirmPassword ? 'text' : 'password'" class="form-control"
            placeholder="Confirmar nueva contraseña" v-model="resetPasswordForm.confirmPassword" required />
          <span class="toggle-password" @click="showConfirmPassword = !showConfirmPassword">
            <i :class="showConfirmPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
          </span>
        </div>

        <button type="submit" class="btn btn-login" :disabled="loadingResetPassword">
          <span v-if="loadingResetPassword" class="spinner-border spinner-border-sm me-2" role="status"
            aria-hidden="true"></span>
          <span v-if="loadingResetPassword" class="loading-text">Cargando...</span>
          <span v-else>Restablecer contraseña</span>
        </button>

        <div class="register-link">
          <a href="#" @click.prevent="returnLogin()">Volver</a>
        </div>
      </form>

      <!-- VERIFY ACCOUNT -->
      <form v-else-if="showVerifyAccount" @submit.prevent="onVerifyCode" novalidate>
        <div class="form-group">
          <input type="text" class="form-control" placeholder="Código de verificación (6 dígitos)" v-model="verifyCode"
            maxlength="6" inputmode="numeric" required
            @input="verifyCode = (verifyCode || '').replace(/[^0-9]/g, '').slice(0, 6)" />
          <small class="timer-text">
            Tiempo restante: <strong>{{ formatTimer(timerSec) }}</strong>
          </small>
        </div>

        <!-- BOTÓN VERIFICAR -->
        <button type="submit" class="btn btn-login" :disabled="loadingVerify">
          <span v-if="loadingVerify" class="spinner-border spinner-border-sm me-2" role="status"
            aria-hidden="true"></span>
          <span v-if="loadingVerify" class="loading-text">Cargando...</span>
          <span v-else>Verificar</span>
        </button>

        <!-- BOTÓN REENVIAR CÓDIGO -->
        <button type="button" class="btn btn-create-account" :disabled="loadingResend || !canResend"
          @click="onResendCode">
          <span v-if="loadingResend" class="spinner-border spinner-border-sm me-2" role="status"
            aria-hidden="true"></span>
          <span v-if="loadingResend" class="loading-text">Cargando...</span>
          <span v-else>Reenviar código</span>
        </button>

        <div class="register-link">
          <a href="#" @click.prevent="returnLogin()">Volver</a>
        </div>
      </form>


      <!-- LOGIN -->
      <form v-else @submit.prevent="onSubmit" novalidate>
        <div class="form-group">
          <input type="text" class="form-control" placeholder="Email" v-model="email" required />
        </div>

        <div class="form-group password-container">
          <input :type="showPassword ? 'text' : 'password'" class="form-control" placeholder="Contraseña" v-model="password" required />
          <span class="toggle-password" @click="showPassword = !showPassword">
            <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
          </span>
        </div>

        <div class="forgot-password">
          <a href="#" @click.prevent="openForgotPassword()">¿Olvidaste tu contraseña?</a>
        </div>
        

        <button type="submit" class="btn btn-login" :disabled="loading">
          <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
          <span v-if="loading" class="loading-text">Cargando...</span>
          <span v-else>Iniciar Sesión</span>
        </button>

        <div class="register-link">
          ¿No tienes cuenta?
          <a href="#" @click.prevent="openCreateAccount()">Regístrate</a>
        </div>
      </form>

      <!-- Modal Términos y Condiciones -->
      <div v-if="showTerms" class="modal-overlay">
        <div class="modal-content-custom">
          <button class="btn-close-x" @click="showTerms = false">&times;</button>
          <h2 class="modal-title">Términos y Condiciones & Política de Privacidad</h2>

          <div class="modal-body-text">
            <p>
              Este espacio ha sido creado para que conozcas quiénes somos, descubras
              nuestra cultura y participes en los programas y procesos de selección
              que ponemos a tu disposición. Al navegar en ella, aceptas estos
              Términos y Condiciones, cuyo objetivo es garantizar un uso responsable y
              transparente.
            </p>

            <h3 class="modal-subtitle">TÉRMINOS Y CONDICIONES</h3>

            <ul class="modal-list">
              <li>
                El usuario se compromete a utilizar la plataforma únicamente con fines
                informativos y de postulación a las posiciones publicadas,
                absteniéndose de realizar actividades ilícitas, fraudulentas o que
                afecten la integridad de los contenidos. Confiamos en que toda la
                información que compartas sea real y actualizada, ya que Agrovisión no
                se responsabiliza por datos falsos o incompletos proporcionados en los
                procesos de selección.
              </li>
              <li>
                Todo el contenido de la plataforma —textos, imágenes, logotipos,
                material audiovisual y demás recursos— es propiedad de Agrovisión o
                cuenta con las autorizaciones correspondientes. Queda prohibida su
                reproducción, distribución o modificación sin autorización expresa.
              </li>
              <li>
                Agrovisión podrá modificar, actualizar o eliminar en cualquier momento
                tanto el contenido de la plataforma como los presentes Términos y
                Condiciones, siempre con el fin de mejorar la experiencia de nuestros
                usuarios. Si tienes consultas sobre el uso de la plataforma, puedes
                comunicarte a través del correo
                <strong>correo@agrovision.com</strong>.
              </li>
            </ul>

            <h3 class="modal-subtitle">POLÍTICAS DE PRIVACIDAD</h3>

            <ul class="modal-list">
              <li>
                En Agrovisión valoramos tu confianza y protegemos la información
                personal que compartes con nosotros. Somos responsables de la
                recopilación y tratamiento de los datos que los usuarios proporcionan
                al registrarse, postular a un proceso de selección o participar en
                nuestros programas e iniciativas corporativas.
              </li>
              <li>
                La información que podemos recopilar incluye datos de contacto (como
                nombre, correo electrónico y teléfono), información curricular y
                profesional, así como datos de navegación obtenidos mediante cookies o
                herramientas analíticas. Estos datos serán utilizados exclusivamente
                para gestionar postulaciones, comunicar actividades vinculadas a
                nuestra cultura y programas, y dar cumplimiento a obligaciones legales
                y regulatorias.
              </li>
              <li>
                Conservamos la información solo durante el tiempo necesario para los
                fines mencionados y, posteriormente, será eliminada o anonimizada.
                Agrovisión aplica medidas de seguridad técnicas y organizativas para
                proteger tus datos frente a accesos no autorizados, pérdidas o
                alteraciones.
              </li>
              <li>
                Tu información no será compartida con terceros, salvo que resulte
                indispensable para el desarrollo de un proceso de selección o por
                obligación legal. Puedes ejercer tus derechos ARCO escribiendo a:
                <strong>datos@agrovision.com</strong>.
              </li>
              <li>
                Agrovisión se reserva el derecho de actualizar esta Política de
                Privacidad en cualquier momento. Toda modificación será publicada en
                la plataforma y entrará en vigor desde su fecha de publicación,
                asegurando que siempre tengas información clara y actualizada sobre el
                manejo de tus datos.
              </li>
            </ul>
          </div>

          <div class="modal-footer-custom">
            <button @click="showTerms = false" class="btn-close-modal">Cerrar</button>
          </div>
        </div>
      </div>
      <!-- /Modal -->
    </div>
  </div>
</template>

<script>
import axiosIns from "@/plugins/axios.js";

export default {
  data() {
    return {
      // Login
      loading: false,
      email: null,
      password: null,
      showPassword: false,

      loadingVerify: false,
      loadingResend: false,

      // Create account
      showCreateAccount: false,
      createAccountForm: {
        name: "",
        username: "",
        ap_paterno: "",
        ap_materno: "",
        email: "",
        password: "",
        acceptTerms: false,
      },

      // Forgot Password
      showForgotPassword: false,
      emailForgotPassword: null,
      forgotEmailNotFound: false,
      showVerifyResetCode: false,
      showResetPasswordForm: false,
      resetVerifyCode: "",
      resetApplicantId: null,
      resetSessionToken: null,
      resetToken: null,
      resetNoticeMessage: "",
      loadingResetPassword: false,
      showNewPassword: false,
      showConfirmPassword: false,
      resetPasswordForm: {
        password: "",
        confirmPassword: "",
      },

      // Terms
      showTerms: false,

      // Verify Account
      showVerifyAccount: false,
      verifyCode: "",
      verifyApplicantId: null,
      timerSec: 150,
      timerRef: null,
      canResend: false,
    };
  },

  methods: {

    onSubmit() {
      this.loading = true
      const yo = this

      const data = JSON.stringify({
        email: yo.email,
        password: yo.password,
      })

      const config = {
        method: "post",
        url: "/talentoagv/loginApplicant/",
        headers: { "Content-Type": "application/json" },
        data,
      }

      axiosIns(config)
        .then(function (response) {
          const resp = response.data || {}
          const isError = resp.is_error
          const result = resp.result || null

          // ✅ Cuenta ACTIVA -> entra al sistema
          if (isError === false) {
            const u = result
            localStorage.setItem(
              "userData",
              JSON.stringify({
                nombres_completos: u.name + " " + u.first_surname + " " + u.second_surname,
                nombres: u.name,
                ap_paterno: u.first_surname,
                ap_materno: u.second_surname,
                username: u.username,
                email: u.email,
                photo: u.s3_url,
                id_usuario: u.id,
              })
            )
            yo.$toastr.success(resp.message || "Bienvenido al Sistema.", "Éxito")
            yo.$router.push("/dashboard_ofertas_laborales")
            return
          }

          // 🔸 Cuenta PENDIENTE -> mostrar cuadro de verificación
          if (isError === true && result && result.status === "P") {
            yo.verifyApplicantId = result.id   // id del postulante para verificar
            yo.verifyCode = ""
            yo.canResend = false

            // Opcional: guardas email/pass para luego autocompletar después de verificar
            yo.createAccountForm.email = yo.email
            yo.createAccountForm.password = yo.password

            // Cambiar vista: ocultar login y mostrar verificación
            yo.showCreateAccount = false
            yo.showForgotPassword = false
            yo.showVerifyAccount = true

            yo.$toastr.info(
              resp.message || "Tu cuenta está pendiente de verificación. Ingresa el código enviado a tu correo.",
              "Verificación requerida"
            )

            yo.startTimer()
            return
          }

          // ❌ Otros errores (usuario incorrecto, cuenta D, etc.)
          yo.$toastr.error(resp.message || "Error de autenticación", "Error de autenticación")
        })
        .catch(function (error) {
          console.log(error)
          const msg = error?.response?.data?.message || "Ocurrió un error al iniciar sesión"
          yo.$toastr.error(msg, "Error")
        })
        .finally(function () {
          yo.loading = false
        })
    },



    /* ---------------- CREATE ACCOUNT ---------------- */
    onCreateAccount() {
      this.loading = true;
      const yo = this;

      // Normalize and trim values
      const name = (yo.createAccountForm.name || "").trim();
      const username = (yo.createAccountForm.username || "").trim();
      const ap_paterno = (yo.createAccountForm.ap_paterno || "").trim();
      const ap_materno = (yo.createAccountForm.ap_materno || "").trim();
      const email = (yo.createAccountForm.email || "").trim();
      const password = (yo.createAccountForm.password || "").trim();
      const acceptTerms = !!yo.createAccountForm.acceptTerms;

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      const allEmpty =
        !acceptTerms &&
        name === "" &&
        username === "" &&
        ap_paterno === "" &&
        ap_materno === "" &&
        email === "" &&
        password === "";

      if (allEmpty) {
        yo.$toastr.warning("Complete los campos del formulario antes de continuar.", "Campos vacíos");
        yo.loading = false;
        return;
      }
      if (name === "") {
        yo.$toastr.warning("Ingresa tu nombre.", "Campo requerido");
        yo.loading = false;
        return;
      }
      /*
      if (username === "") {
        yo.$toastr.warning("Ingresa un nombre de usuario.", "Campo requerido");
        yo.loading = false;
        return;
      }
      */
      if (ap_paterno === "") {
        yo.$toastr.warning("Ingresa tu apellido paterno.", "Campo requerido");
        yo.loading = false;
        return;
      }
      if (ap_materno === "") {
        yo.$toastr.warning("Ingresa tu apellido materno.", "Campo requerido");
        yo.loading = false;
        return;
      }
      if (email === "") {
        yo.$toastr.warning("Ingresa tu correo electrónico.", "Campo requerido");
        yo.loading = false;
        return;
      }
      if (!emailRegex.test(email)) {
        yo.$toastr.warning("Ingresa un correo electrónico válido (ej: usuario@correo.com).", "Email inválido");
        yo.loading = false;
        return;
      }
      if (password === "") {
        yo.$toastr.warning("Ingresa una contraseña.", "Campo requerido");
        yo.loading = false;
        return;
      }
      if (!acceptTerms) {
        yo.$toastr.warning("Debes aceptar los Términos y Condiciones.", "Aviso");
        yo.loading = false;
        return;
      }

      const data = JSON.stringify({
        name: name,
        username: username,
        first_surname: ap_paterno,
        second_surname: ap_materno,
        email: email,
        password: password,
        terms_conds_polits: acceptTerms,
      });

      const config = {
        method: "post",
        url: "/talentoagv/create-applicant-account/",
        headers: { "Content-Type": "application/json" },
        data,
      };

      axiosIns(config)
        .then(function (response) {
          const isError = response.data && response.data.is_error;
          const errorFlag = Array.isArray(isError) ? isError[0] : isError;

          if (errorFlag === false || errorFlag === "false" || !errorFlag) {
            // IMPORTANTE: aquí NO se manda al dashboard; se manda a verificación
            let u = response.data["result"] || {};
            yo.verifyApplicantId = u.id || null;
            yo.verifyCode = "";
            yo.canResend = false;

            yo.showCreateAccount = false;
            yo.showForgotPassword = false;
            yo.showVerifyAccount = true;

            yo.$toastr.success(
              response.data["message"] || "Te enviamos un código a tu correo (válido 2m 30s).",
              "Verificación"
            );

            yo.startTimer();
          } else {
            yo.$toastr.error(response.data["message"] || "Error al crear cuenta", "Error");
          }
        })
        .catch(function (error) {
          const serverMsg = error?.response?.data?.message;
          if (serverMsg) {
            yo.$toastr.error(serverMsg, "Error");
          } else {
            console.error(error);
            yo.$toastr.error("Ocurrió un error al crear la cuenta", "Error");
          }
        })
        .finally(function () {
          yo.loading = false;
        });
    },

    /* ---------------- VERIFY ACCOUNT ---------------- */
    startTimer() {
      this.timerSec = 150
      this.canResend = false

      if (this.timerRef) clearInterval(this.timerRef)

      this.timerRef = setInterval(() => {
        if (this.timerSec > 0) {
          this.timerSec -= 1
        }

        if (this.timerSec <= 0) {
          this.timerSec = 0
          clearInterval(this.timerRef)
          this.timerRef = null

          // Ya no bloqueamos la pantalla ni regresamos al registro.
          // Solo habilitamos el botón de "Reenviar código".
          this.canResend = true
        }
      }, 1000)
    },



    formatTimer(sec) {
      const m = Math.floor(sec / 60);
      const s = sec % 60;
      return `${m}:${String(s).padStart(2, "0")}`;
    },

    onVerifyCode() {
      this.loadingVerify = true
      const yo = this

      if (!yo.verifyApplicantId) {
        yo.$toastr.error("No se encontró el ID de verificación. Regístrate nuevamente.", "Error")
        yo.loadingVerify = false
        return
      }

      const config = {
        method: "post",
        url: "/talentoagv/verify-applicant-email-code/",
        headers: { "Content-Type": "application/json" },
        data: JSON.stringify({ id: yo.verifyApplicantId, code: yo.verifyCode }),
      }

      axiosIns(config)
        .then(function (response) {
          if (response.data && response.data.is_error === false) {
            if (yo.timerRef) clearInterval(yo.timerRef)
            yo.timerRef = null

            yo.$toastr.success(response.data.message || "Cuenta verificada.", "OK")

            yo.showVerifyAccount = false
            yo.showCreateAccount = false
            yo.showForgotPassword = false

            yo.email = yo.createAccountForm.email || yo.email
            yo.password = yo.createAccountForm.password || yo.password
          } else {
            yo.$toastr.error(response.data.message || "No se pudo verificar.", "Error")
          }
        })
        .catch(function (error) {
          const msg = error?.response?.data?.message || "Error al verificar"
          yo.$toastr.error(msg, "Error")

          const lower = (msg || "").toLowerCase()

          if (
            lower.includes("venció") ||
            lower.includes("vencio") ||
            lower.includes("anul") ||
            lower.includes("solicita un nuevo código") ||
            lower.includes("solicita uno nuevo")
          ) {
            yo.canResend = true
            yo.timerSec = 0
          }
        })
        .finally(function () {
          yo.loadingVerify = false
        })
    },



    onResendCode() {
      this.loadingResend = true
      const yo = this

      if (!yo.verifyApplicantId) {
        yo.$toastr.error("No se encontró el ID de verificación. Regístrate nuevamente.", "Error")
        yo.loadingResend = false
        return
      }

      const config = {
        method: "post",
        url: "/talentoagv/resend-applicant-email-code/",
        headers: { "Content-Type": "application/json" },
        data: JSON.stringify({ id: yo.verifyApplicantId }),
      }

      axiosIns(config)
        .then(function (response) {
          if (response.data && response.data.is_error === false) {
            yo.$toastr.success(
              response.data.message || "Se envió un nuevo código (2m 30s).",
              "Código reenviado"
            )
            yo.verifyCode = ""
            yo.startTimer()
          } else {
            yo.$toastr.error(
              response.data.message || "No se pudo reenviar el código.",
              "Error"
            )
          }
        })
        .catch(function (error) {
          const msg = error?.response?.data?.message || "Error al reenviar"
          yo.$toastr.error(msg, "Error")

          const lower = (msg || "").toLowerCase()
          if (lower.includes("eliminad") || lower.includes("venció") || lower.includes("vencio")) {
            yo.showVerifyAccount = false
            yo.showCreateAccount = true
          }
        })
        .finally(function () {
          yo.loadingResend = false
        })
    },


    /* ---------------- FORGOT / RESET PASSWORD ---------------- */
    openForgotPassword() {
      if (this.timerRef) clearInterval(this.timerRef);
      this.timerRef = null;

      this.showCreateAccount = false;
      this.showVerifyAccount = false;
      this.showVerifyResetCode = false;
      this.showResetPasswordForm = false;
      this.showForgotPassword = true;

      this.forgotEmailNotFound = false;
      this.emailForgotPassword = this.email ? String(this.email).trim() : "";
      this.resetVerifyCode = "";
      this.resetApplicantId = null;
      this.resetSessionToken = null;
      this.resetToken = null;
      this.resetNoticeMessage = "";
    },

    goToCreateAccountFromForgot() {
      const enteredEmail = (this.emailForgotPassword || "").trim();
      this.openCreateAccount();
      if (enteredEmail) {
        this.createAccountForm.email = enteredEmail;
      }
    },

    sendRecoveryEmail() {
      const yo = this;
      const email = (yo.emailForgotPassword || "").trim();
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      yo.forgotEmailNotFound = false;

      if (email === "") {
        yo.$toastr.warning("Ingresa tu correo electrónico.", "Campo requerido");
        return;
      }

      if (!emailRegex.test(email)) {
        yo.$toastr.warning(
          "Ingresa un correo electrónico válido (ej: usuario@correo.com).",
          "Email inválido"
        );
        return;
      }

      yo.loading = true;

      const config = {
        method: "post",
        url: "/talentoagv/request-password-reset/",
        headers: { "Content-Type": "application/json" },
        data: JSON.stringify({ email }),
      };

      axiosIns(config)
        .then(function (response) {
          const resp = response.data || {};
          if (resp.is_error === false) {
            const result = resp.result || {};
            yo.resetApplicantId = result.id || null;
            yo.resetSessionToken = result.reset_session_token || null;
            yo.resetVerifyCode = "";
            yo.canResend = false;
            yo.resetNoticeMessage =
              resp.message ||
              "SI EL CORREO LE PERTENECE A UNA CUENTA SE ENVIARÁ EL CORREO DE REESTABLECIMIENTO";

            yo.showForgotPassword = false;
            yo.showVerifyResetCode = true;

            yo.$toastr.info(yo.resetNoticeMessage, "Aviso de restablecimiento");
            yo.startTimer();
          } else {
            if (resp.account_exists === false) {
              yo.forgotEmailNotFound = true;
            }
            yo.$toastr.warning(
              resp.message ||
                "El correo ingresado no existe o no está vinculado a una cuenta.",
              "Cuenta no encontrada"
            );
          }
        })
        .catch(function (error) {
          const errData = error?.response?.data || {};
          const status = error?.response?.status;
          const msg =
            errData.message ||
            "Ocurrió un error al procesar la solicitud de restablecimiento.";

          if (status === 404 || errData.account_exists === false) {
            yo.forgotEmailNotFound = true;
            yo.$toastr.warning(msg, "Cuenta no encontrada");
          } else {
            yo.$toastr.error(msg, "Error");
          }
        })
        .finally(function () {
          yo.loading = false;
        });
    },

    onVerifyResetCode() {
      const yo = this;
      const code = (yo.resetVerifyCode || "").trim();

      if (!yo.resetApplicantId || !yo.resetSessionToken) {
        yo.$toastr.error(
          "La sesión de recuperación no es válida. Solicita el código nuevamente.",
          "Error"
        );
        yo.openForgotPassword();
        return;
      }

      if (code.length !== 6 || !/^\d{6}$/.test(code)) {
        yo.$toastr.warning(
          "Ingresa el código de verificación de 6 dígitos.",
          "Código incompleto"
        );
        return;
      }

      yo.loadingVerify = true;

      const config = {
        method: "post",
        url: "/talentoagv/verify-password-reset-code/",
        headers: { "Content-Type": "application/json" },
        data: JSON.stringify({
          id: yo.resetApplicantId,
          code: code,
          reset_session_token: yo.resetSessionToken,
        }),
      };

      axiosIns(config)
        .then(function (response) {
          const resp = response.data || {};
          if (resp.is_error === false) {
            if (yo.timerRef) clearInterval(yo.timerRef);
            yo.timerRef = null;

            const result = resp.result || {};
            yo.resetToken = result.reset_token || null;
            yo.resetPasswordForm.password = "";
            yo.resetPasswordForm.confirmPassword = "";
            yo.showNewPassword = false;
            yo.showConfirmPassword = false;

            yo.showVerifyResetCode = false;
            yo.showResetPasswordForm = true;

            yo.$toastr.success(
              resp.message || "Código verificado correctamente.",
              "Verificación exitosa"
            );
          } else {
            yo.$toastr.error(
              resp.message || "No se pudo verificar el código.",
              "Error"
            );
          }
        })
        .catch(function (error) {
          const msg =
            error?.response?.data?.message || "Error al verificar el código.";
          yo.$toastr.error(msg, "Error");

          const lower = (msg || "").toLowerCase();
          if (
            lower.includes("venció") ||
            lower.includes("vencio") ||
            lower.includes("anul") ||
            lower.includes("solicita un nuevo código") ||
            lower.includes("solicita uno nuevo")
          ) {
            yo.canResend = true;
            yo.timerSec = 0;
          }
        })
        .finally(function () {
          yo.loadingVerify = false;
        });
    },

    onResendResetCode() {
      const yo = this;

      if (!yo.resetApplicantId || !yo.resetSessionToken) {
        yo.$toastr.error(
          "Sesión inválida. Solicita el restablecimiento nuevamente.",
          "Error"
        );
        yo.openForgotPassword();
        return;
      }

      yo.loadingResend = true;

      const config = {
        method: "post",
        url: "/talentoagv/resend-password-reset-code/",
        headers: { "Content-Type": "application/json" },
        data: JSON.stringify({
          id: yo.resetApplicantId,
          reset_session_token: yo.resetSessionToken,
        }),
      };

      axiosIns(config)
        .then(function (response) {
          const resp = response.data || {};
          if (resp.is_error === false) {
            yo.$toastr.success(
              resp.message || "Se envió un nuevo código a tu correo (2m 30s).",
              "Código reenviado"
            );
            yo.resetVerifyCode = "";
            yo.startTimer();
          } else {
            yo.$toastr.error(
              resp.message || "No se pudo reenviar el código.",
              "Error"
            );
          }
        })
        .catch(function (error) {
          const msg =
            error?.response?.data?.message || "Error al reenviar el código.";
          yo.$toastr.error(msg, "Error");
        })
        .finally(function () {
          yo.loadingResend = false;
        });
    },

    onSubmitResetPassword() {
      const yo = this;
      const newPassword = (yo.resetPasswordForm.password || "").trim();
      const confirmPassword = (yo.resetPasswordForm.confirmPassword || "").trim();

      if (!yo.resetApplicantId || !yo.resetToken) {
        yo.$toastr.error(
          "Tu sesión de restablecimiento expiró. Solicita un nuevo código.",
          "Error"
        );
        yo.openForgotPassword();
        return;
      }

      if (newPassword === "") {
        yo.$toastr.warning("Ingresa tu nueva contraseña.", "Campo requerido");
        return;
      }

      if (newPassword.length < 6) {
        yo.$toastr.warning(
          "La nueva contraseña debe tener al menos 6 caracteres.",
          "Contraseña corta"
        );
        return;
      }

      if (confirmPassword === "") {
        yo.$toastr.warning(
          "Confirma tu nueva contraseña.",
          "Campo requerido"
        );
        return;
      }

      if (newPassword !== confirmPassword) {
        yo.$toastr.warning("Las contraseñas no coinciden.", "Aviso");
        return;
      }

      yo.loadingResetPassword = true;

      const config = {
        method: "post",
        url: "/talentoagv/reset-applicant-password/",
        headers: { "Content-Type": "application/json" },
        data: JSON.stringify({
          id: yo.resetApplicantId,
          reset_token: yo.resetToken,
          password: newPassword,
          confirm_password: confirmPassword,
        }),
      };

      axiosIns(config)
        .then(function (response) {
          const resp = response.data || {};
          if (resp.is_error === false) {
            yo.$toastr.success(
              resp.message ||
                "Contraseña restablecida correctamente. Ya puedes iniciar sesión.",
              "Éxito"
            );
            yo.email = yo.emailForgotPassword || yo.email;
            yo.password = "";
            yo.returnLogin();
          } else {
            yo.$toastr.error(
              resp.message || "No se pudo restablecer la contraseña.",
              "Error"
            );
          }
        })
        .catch(function (error) {
          const msg =
            error?.response?.data?.message ||
            "Error al restablecer la contraseña.";
          yo.$toastr.error(msg, "Error");
        })
        .finally(function () {
          yo.loadingResetPassword = false;
        });
    },

    /* ---------------- MISC ---------------- */
    openCreateAccount() {
      // limpiar temporizadores si venía de verify
      if (this.timerRef) clearInterval(this.timerRef);
      this.timerRef = null;

      this.showCreateAccount = true;
      this.showForgotPassword = false;
      this.showVerifyAccount = false;
      this.showVerifyResetCode = false;
      this.showResetPasswordForm = false;
      this.forgotEmailNotFound = false;
    },

    returnLogin() {
      if (this.timerRef) clearInterval(this.timerRef)
      this.timerRef = null

      this.showCreateAccount = false
      this.showForgotPassword = false
      this.showVerifyAccount = false
      this.showVerifyResetCode = false
      this.showResetPasswordForm = false

      this.forgotEmailNotFound = false
      this.verifyCode = ""
      this.resetVerifyCode = ""
      this.resetApplicantId = null
      this.resetSessionToken = null
      this.resetToken = null
      this.resetNoticeMessage = ""
      this.resetPasswordForm.password = ""
      this.resetPasswordForm.confirmPassword = ""
      this.canResend = false
    },


    openTerms() {
      this.showTerms = true;
    },

    handleKeydown(e) {
      if (this.showTerms && e.key === "Escape") {
        this.showTerms = false;
      }
    },
  },

  mounted() {
    document.addEventListener("keydown", this.handleKeydown);
  },

  beforeUnmount() {
    document.removeEventListener("keydown", this.handleKeydown);
    if (this.timerRef) clearInterval(this.timerRef);
    this.timerRef = null;
  },
};
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),
    url("@/assets/talento_agv/img/cultura/vida_empresa_LK_05.jpg") center/cover no-repeat;
  position: relative;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.logo-top {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 0;
  position: absolute;
  left: 0;
  top: -75px;
}

.logo-top img {
  height: 150px;
  max-width: 180px;
}

.login-card {
  background: rgba(255, 255, 255, 0.61);
  border-radius: 20px;
  padding: 4.5rem 2.5rem 2.5rem 2.5rem;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
  position: relative;
}

.logo-section {
  text-align: center;
  margin-bottom: 2rem;
}

.welcome-text {
  color: #000;
  font-size: 1rem;
  font-weight: 500;
  margin: 0;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-control {
  border: none;
  border-bottom: 1px solid var(--bg-primary-as);
  background: transparent;
  padding: 12px 0;
  font-size: 1rem;
  transition: all 0.3s ease;
  border-radius: 0;
  width: 100%;
  outline: none;
}

.form-control:focus {
  border-bottom-color: var(--bg-primary-as);
  box-shadow: none;
  background: transparent;
}

.form-control::placeholder {
  color: #adb5bd;
}

.timer-text {
  display: block;
  margin-top: 10px;
  color: #2d3748;
  font-size: 0.9rem;
}

.forgot-password {
  text-align: center;
  margin: 1rem 0 2rem 0;
}

.forgot-password a {
  color: var(--bg-primary-as-light);
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: bold;
}

.forgot-password a:hover {
  text-decoration: underline;
}

.btn {
  border: none;
  padding: 12px 0;
  border-radius: 25px;
  font-weight: 600;
  width: 100%;
  transition: all 0.3s ease;
  margin-bottom: 1.5rem;
  cursor: pointer;
}

.btn-login {
  background: var(--bg-primary-as);
  color: white;
}

.btn-login:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(44, 62, 80, 0.3);
  background: var(--bg-primary-as-light);
  color: white;
}

.spinner-border {
  color: var(--bg-primary-as) !important;
  border-color: var(--bg-primary-as) transparent var(--bg-primary-as) transparent !important;
}

.loading-text {
  color: var(--bg-primary-as);
  font-weight: 600;
}

.register-link {
  text-align: center;
  color: #000;
  font-size: 0.9rem;
}

.register-link a {
  color: #e74c3c;
  text-decoration: none;
  font-weight: 600;
}

.register-link a:hover {
  text-decoration: underline;
}

.local-back-btn {
  color: var(--bg-primary-as-light);
  text-decoration: none;
  font-weight: 500;
  display: flex;
  align-items: start;
  gap: 5px;
  cursor: pointer;
  position: absolute;
  top: 25px;
  margin-top: 10px;
}

.local-back-btn:hover {
  text-decoration: underline;
}

.btn-create-account {
  border: none;
  padding: 12px 0;
  border-radius: 25px;
  font-weight: 600;
  width: 100%;
  transition: all 0.3s ease;
  margin-bottom: 1.5rem;
  cursor: pointer;
  background: var(--bg-primary-as-light);
  color: white;
}

.btn-create-account:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(44, 62, 80, 0.3);
  background: var(--bg-primary-as);
  color: white;
}

.text-conditions {
  color: var(--bg-primary-as-light);
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content-custom {
  background-color: white;
  width: 90%;
  max-width: 800px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  padding: 2rem;
  max-height: 85vh;
  overflow-y: auto;
  position: relative;
  display: flex;
  flex-direction: column;
}

.modal-content-custom::-webkit-scrollbar {
  width: 8px;
}

.modal-content-custom::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.modal-content-custom::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.modal-content-custom::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.btn-close-x {
  position: absolute;
  top: 15px;
  right: 20px;
  background: none;
  border: none;
  font-size: 2rem;
  line-height: 1;
  color: #aaa;
  cursor: pointer;
  transition: color 0.3s;
}

.btn-close-x:hover {
  color: #333;
}

.modal-title {
  font-size: 1.5rem;
  font-weight: 600;
  text-align: center;
  margin-bottom: 1.5rem;
  color: #333;
}

.modal-body-text {
  color: #4a5568;
  font-size: 0.95rem;
  line-height: 1.6;
  text-align: justify;
}

.modal-subtitle {
  font-size: 1.1rem;
  font-weight: 600;
  margin-top: 1.5rem;
  margin-bottom: 0.5rem;
  color: #2d3748;
}

.modal-list {
  list-style-type: disc;
  padding-left: 1.5rem;
  margin-bottom: 1rem;
}

.modal-list li {
  margin-bottom: 0.5rem;
}

.modal-footer-custom {
  text-align: center;
  margin-top: 2rem;
}

.btn-close-modal {
  background-color: var(--bg-primary-as);
  color: white;
  border: none;
  padding: 10px 30px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s;
}

/* Mejora en el input de password */
.btn-close-modal:hover {
  background-color: var(--bg-primary-as-light);
}

.password-container {
  position: relative;
}

.password-container .form-control {
  padding-right: 40px;
}

.toggle-password {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #888;
}

.toggle-password:hover {
  color: #333;
}

.recovery-alert {
  border-radius: 12px;
  padding: 12px 14px;
  margin-bottom: 1.25rem;
  font-size: 0.88rem;
  line-height: 1.45;
  text-align: center;
  font-weight: 500;
}

.recovery-alert-info {
  background: rgba(238, 246, 255, 0.92);
  border: 1px solid var(--bg-primary-as-light, #2c3e50);
  color: #010133;
  font-weight: 600;
}

.recovery-alert-error {
  background: rgba(254, 242, 242, 0.95);
  border: 1px solid #f5c2c7;
  color: #842029;
}
</style>
